<script setup>
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
const LOG = 'log';

//Define props
const props = defineProps({
  mode: {
    type: String,
    default: ''
  },
  data: {
    type: Object,
    default: () => ({})
  },
  maxWidth: {
    type: String,
    default: '160px'
  }
});

//Define emits
defineEmits(['onChartTile']);

const tooltipElementRef = ref(null);
const { locale } = useI18n();

//Define methods
const getDescription = () => {
  if (locale.value === 'en') return props.data.metricDescriptionEn?.replace(/<br\s*\/?>/gi, '\n');
  return props.data.metricDescription?.replace(/<br\s*\/?>/gi, '\n');
};
const getTarget = () => {
  if (locale.value === 'en') return props.data.productTargetTypeEn;
  return props.data.productTargetType;
};

// Define compute
const dataObj = computed(() => {
  if (props.mode === LOG) {
    const title = props.data.logSq || '';
    const path = props.data.logPath || '';
    return {
      title,
      path
    };
  }
  const name = props.data.metricName || props.data.name || '-';
  const description = getDescription() || '-';
  const target = getTarget() || '-';
  const unit = props.data.metricUnit || '-';
  return {
    name,
    description,
    target,
    unit
  };
});
const elementRef = computed(() => tooltipElementRef.value?.innerHTML || '');

//hooks
onMounted(() => {});
</script>
<template>
  <div class="chart-title-container">
    <div
      v-lego-tooltip="{
        value: elementRef,
        position: 'top',
        moreAction: true,
        isShowHTML: true
      }"
      class="chart-title-container_text"
      :style="{ maxWidth }"
    >
      <c-label :tooltip="false" :ellipsis="true">{{ dataObj.name }}</c-label>
    </div>
  </div>
  <div ref="tooltipElementRef" v-show="false" class="chart-title-tooltip">
    <table>
      <template v-if="mode === 'log'">
        <tr class="container-tooltip__content">
          <td class="container-tooltip__content-label">{{ $t('label.fileName') }}:</td>
          <td class="container-tooltip__content-name">{{ dataObj.title }}</td>
        </tr>
        <tr class="container-tooltip__content">
          <td class="container-tooltip__content-label">{{ $t('label.filePath') }}:</td>
          <td class="container-tooltip__content-name">{{ dataObj.path }}</td>
        </tr>
      </template>
      <template v-else>
        <tr class="container-tooltip__content">
          <td class="container-tooltip__content-label">{{ $t('label.tooltipName') }}:</td>
          <td class="container-tooltip__content-name">{{ dataObj.name }}</td>
        </tr>
        <tr class="container-tooltip__content">
          <td class="container-tooltip__content-label">{{ $t('label.description') }}:</td>
          <td class="container-tooltip__content-name">{{ dataObj.description }}</td>
        </tr>
        <tr class="container-tooltip__content">
          <td class="container-tooltip__content-label">{{ $t('label.targetTooltip') }}:</td>
          <td class="container-tooltip__content-name">{{ dataObj.target }}</td>
        </tr>
        <tr class="container-tooltip__content">
          <td class="container-tooltip__content-label">{{ $t('label.collectionUnit') }}:</td>
          <td class="container-tooltip__content-name">{{ dataObj.unit }}</td>
        </tr>
      </template>
    </table>
  </div>
</template>

<style lang="scss" scoped>
.chart-title-container {
  display: flex;
  align-items: center;
  gap: 24px;

  &_text {
    :deep(.c-label) {
      cursor: default;
      font-weight: 700 !important;
      color: #2e3138 !important;
      line-height: 28px !important;
    }
  }
}

.container-tooltip__content-label {
  vertical-align: top;
  white-space: nowrap;
}
.container-tooltip__content-name {
  word-break: break-word;
  word-wrap: break-word;
}
</style>
